var Handlebars = require("handlebars/runtime");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<option value=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.fc : depth0)) != null ? stack1.value : stack1), depth0))
    + "\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.fc : depth0)) != null ? stack1.text : stack1), depth0))
    + "</option>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<li data-value=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.fc : depth0)) != null ? stack1.value : stack1), depth0))
    + "\"><span>"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.fc : depth0)) != null ? stack1.text : stack1), depth0))
    + "</span></li>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.isMobile : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "");
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./components/svgchart/src/html/menuBar/intervalSelectOption.html
// module id = 32
// module chunks = 0